import { formatTime } from 'infrastructure/functions';
import classNames from 'classnames';
import { useMemo, type FC } from 'react';
import { useTranslation } from 'react-i18next';

import styles from './styles.module.scss';
import TranscriptError from './error';

import type { TranscriptItem } from 'infrastructure/hooks/calls/use-get-call-transcribe/types';

interface Props {
  transcripts?: TranscriptItem[] | null;
  currentTimeSeconds: number;
  setCurrentTimeSeconds: (time: number) => void;
}

const TranscriptList: FC<Props> = ({
  transcripts,
  currentTimeSeconds,
  setCurrentTimeSeconds,
}) => {
  const { t } = useTranslation();

  const normalizedTranscripts = useMemo(() => {
    if (!transcripts) {
      return [];
    }

    return transcripts.map((transcript) => {
      const isActive =
        transcript.beginOffsetSeconds <= currentTimeSeconds &&
        transcript.endOffsetSeconds >= currentTimeSeconds;
      return {
        ...transcript,
        isActive,
      };
    });
  }, [transcripts?.length, currentTimeSeconds]);

  if (!transcripts) {
    return null;
  }

  if (transcripts.length === 0) {
    return <TranscriptError message={t('messages.noTranscriptsFound')} />;
  }

  return (
    <>
      {normalizedTranscripts.map((transcript) => (
        <div
          key={`${transcript.beginOffsetSeconds}-${transcript.role}`}
          className={classNames(styles['transcript-item'], {
            [styles.active]: transcript.isActive,
          })}
        >
          <div className={styles['transcript-header']}>
            <button
              className={styles['transcript-time']}
              onClick={() =>
                setCurrentTimeSeconds(transcript.beginOffsetSeconds)
              }
            >
              {formatTime(transcript.beginOffsetSeconds)}
            </button>
            <div className={styles['transcript-role']}>
              {transcript.role}:{' '}
              <span className={styles['transcript-content']}>
                {transcript.text}
              </span>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TranscriptList;
